import { render, staticRenderFns } from "./ModalTutorial.vue?vue&type=template&id=73971cae&"
import script from "./ModalTutorial.vue?vue&type=script&lang=js&"
export * from "./ModalTutorial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCarousel,VCarouselItem,VProgressCircular})
